import { Career } from '../models/career.model';

export const CAREERS: Career[] = [
  {
    'category': 'intern',
    'banner': 'intern.png',
    'highlight': {
      'title1': '',
      'title2': '一次获得两个实习经验＋导师推荐信',
      'desc': [
        '还在为没有实习经验所苦恼？连实习面试都拿不到？',
        '没有行业相关背景技能，其实这才是问题的根本！'
      ]
    },
    'projectDesc': {
      'title': '藤途实习项目',
      'desc': [
        {
          'descType': 'regular',
          'content': '藤途帮你从根本解决问题，加强行业基础技能。跟着专属匹配的行业导师'
        },
        {
          'descType': 'regular',
          'content': '实际操作实习项目'
        },
        {
          'descType': 'regular',
          'content': '，让理论与实操对接，'
        },
        {
          'descType': 'regular',
          'content': '加强行业实战经验'
        },
        {
          'descType': 'regular',
          'content': '，提升行业技能。项目结束后取得'
        },
        {
          'descType': 'regular',
          'content': '项目证书'
        },
        {
          'descType': 'regular',
          'content': '，并获得行业导师推荐信 ，更保证取得面试。含金量最高的实习项目，让学生行业技能全面提升，不再担心找不到实习。导师涵盖各个热门行业，包含金融、会计、咨询、互联、快消、媒体、机械......等业界资深大神，更有藤途顾问一路在旁协助同学。'
        },
        {
          'descType': 'regular',
          'content': ''
        },
        {
          'descType': 'regular',
          'content': ''
        }
      ],
      'desc2': [],
    },
    'flowDiagramItems': [
      {
        'title': '个人竞争力评估',
        'desc': '-专业藤途顾问将对学员进行背景能力及行业技能需求评估，并协助订定目标行业及岗位',
        'img': '1.png'
      },
      {
        'title': '专属行业导师匹配',
        'desc': '-针对学员的行业技能需求，匹配最适合的行业导师',
        'img': '2.png'
      },
      {
        'title': '针对岗位技能制定实习项目',
        'desc': '-由行业导师針对学生目标行业崗位，有针对性的制定专属实习项目规划，帮助学员补足行业技能及专业知识',
        'img': '3.png'
      },
      {
        'title': '实习项目操作',
        'desc': '-由行业导师手把手运用行业case，带领学生操作实习项目。借由操作实习项目的过程，加强行业技能及知识背景',
        'img': '4.png'
      },
      {
        'title': '实习项目成果评估',
        'desc': '-项目结束后，导师将会进行项目成果评估，提供学员完整的实习成果总结和反馈',
        'img': '5.png'
      },
      {
        'title': '简历精修/模拟面试',
        'desc': '-此实习项目包含简历精修及模拟面试，保证学员在参加完实习项目的三个月内，能顺利取得面试机会',
        'img': '6.png'
      },
    ],
    'goal': '直通心仪企业，是学员与藤途的共同目标！',
    'duration': '课程时长：可依照学员时间安排调整，建议三个月内完成课程。',
    'achievements': [
      '別人拿不走的行业基础知识及技能',
      '简历背景经验相关度大幅提升',
      '项目证明',
      '实习Offer'
    ],
    'welfare': [
      {
        'welfareItems': [
          {
            'descType': 'regular',
            'content': '藤途顾问'
          },
          {
            'descType': 'highlighting',
            'content': '一对一'
          },
          {
            'descType': 'regular',
            'content': '全程辅助及咨询'
          }
        ]
      },
      {
        'welfareItems': [
          {
            'descType': 'regular',
            'content': '保证取得'
          },
          {
            'descType': 'regular',
            'content': '面试机会'
          }
        ]
      },
      {
        'welfareItems': [
          {
            'descType': 'regular',
            'content': '享有藤途'
          },
          {
            'descType': 'highlighting',
            'content': '內推资源'
          }
        ]
      },
      {
        'welfareItems': [
          {
            'descType': 'regular',
            'content': '免费'
          },
          {
            'descType': 'highlighting',
            'content': '求职干货'
          },
          {
            'descType': 'regular',
            'content': '福利(网申题库、面经等)'
          }
        ]
      }
    ]
  },
  {
    'category': 'full-time',
    'banner': 'full-time.jpg',
    'highlight': {
      'title1': '',
      'title2': '增强行业技能及进阶知识 直推名企',
      'desc': [
        '拥有基本专业知识，却觉得行业技能不足？',
        '觉得理论与实做对接不上？'
      ]
    },
    'projectDesc': {
      'title': '藤途全职实操项目',
      'desc': [
        {
          'descType': 'regular',
          'content': '藤途全职实操项目，帮助学员'
        },
        {
          'descType': 'regular',
          'content': '提升行业实操技能'
        },
        {
          'descType': 'regular',
          'content': '及'
        },
        {
          'descType': 'regular',
          'content': '加强进阶行业知识'
        },
        {
          'descType': 'regular',
          'content': '。跟着专属匹配的行业导师实际操作行业内项目内容，让'
        },
        {
          'descType': 'regular',
          'content': '理论与实操对接'
        },
        {
          'descType': 'regular',
          'content': '，直接加强行业实战经验，全面提升行业技能。行业导师将为学生'
        },
        {
          'descType': 'regular',
          'content': '制定专属项目内容'
        },
        {
          'descType': 'regular',
          'content': ' ，学生享有'
        },
        {
          'descType': 'regular',
          'content': '藤途独家内推'
        },
        {
          'descType': 'regular',
          'content': '，更'
        },
        {
          'descType': 'regular',
          'content': '保证取得面试机会'
        },
        {
          'descType': 'regular',
          'content': '，一举'
        },
        {
          'descType': 'regular',
          'content': '获得Offer'
        },
        {
          'descType': 'regular',
          'content': '，。 导师涵盖各个热门行业，包含金融、会计、咨询、互联、快消、媒体、机械……等等，更拥有资深专业实务经验。藤途顾问在项目期间，将会一路在旁协助同学提供咨询服务。三个月内'
        },
        {
          'descType': 'regular',
          'content': '保证取得面试，获取offer'
        },
        {
          'descType': 'regular',
          'content': '。'
        }
      ],
      'desc2': []
    },
    'flowDiagramItems': [
      {
        'title': '个人竞争力评估',
        'desc': '-专业藤途顾问将对学员进行背景能力及行业技能需求评估，确认目标行业/岗位技能培训内容',
        'img': '1.png'
      },
      {
        'title': '专属行业导师匹配',
        'desc': '-针对学员的行业技能需求，匹配最适合的行业导师',
        'img': '2.png'
      },
      {
        'title': '针对岗位技能制定实操项目主题',
        'desc': '-由行业导师針对学生目标行业岗位，有针对性的制定专属实操项目规划，帮助学员补足行业技能及加强行业深入知识',
        'img': '3.png'
      },
      {
        'title': '专业项目实操',
        'desc': '-由行业导师手把手运用行业实际case，带领学生操做1-2进阶项目。借由操作行业项目的过程，学习行业技能並和所学知识对接',
        'img': '4.png'
      },
      {
        'title': '项目成果评估',
        'desc': '-项目结束后，导师将会进行项目成果评估，提供学员完整的项目成果总结和反馈',
        'img': '5.png'
      },
      {
        'title': '简历精修/模拟面试',
        'desc': '-此实操项目包含简历精修及模拟面试，保证学员在参加完实操项目的三个月内，能顺利取得面试机会',
        'img': '6.png'
      },
    ],
    'goal': '直通心仪企业，是学员与藤途的共同目标！',
    'duration': '课程时长：可依照学员时间安排调整，建议三至六个月内完成课程。',
    'achievements': [
      '获得进阶行业实操技能和知识',
      '简历背景经验相关度大幅提升',
      '全职面试',
      '全职Offer'
    ],
    'welfare': [
      {
        'welfareItems': [
          {
            'descType': 'regular',
            'content': '藤途顾问'
          },
          {
            'descType': 'highlighting',
            'content': '一对一'
          },
          {
            'descType': 'regular',
            'content': '全程辅助及咨询'
          }
        ]
      },
      {
        'welfareItems': [
          {
            'descType': 'regular',
            'content': '保证取得'
          },
          {
            'descType': 'highlighting',
            'content': '面试机会'
          }
        ]
      },
      {
        'welfareItems': [
          {
            'descType': 'regular',
            'content': '享有藤途'
          },
          {
            'descType': 'highlighting',
            'content': '独家内推资源'
          }
        ]
      },
      {
        'welfareItems': [
          {
            'descType': 'regular',
            'content': '优先享有藤途'
          },
          {
            'descType': 'highlighting',
            'content': '直推岗位'
          }
        ]
      },
      {
        'welfareItems': [
          {
            'descType': 'regular',
            'content': '免费'
          },
          {
            'descType': 'highlighting',
            'content': '求职干货'
          },
          {
            'descType': 'regular',
            'content': '福利(网申题库、面经等)'
          }
        ]
      }
    ]
  },
  {
    'category': 'enterprise',
    'banner': 'enterprise.jpg',
    'highlight': {
      'title1': '',
      'title2': '以名企为目标 制定长期职业培訓计划',
      'desc': [
        '',
        ''
      ]
    },
    'projectDesc': {
      'title': '藤途名企大牛养成计划',
      'desc': [
        {
          'descType': 'regular',
          'content': '针对大一、大二、大三、研一，有至少一年时间参与项目、且有志进入名企的学生。'
        }
      ],
      'desc2': [
        {
          'descType': 'regular',
          'content': '体系化培养学生职业能力，为学生进行长期职业规划，从简历，面试，人脉，自身技能四个方向逐一攻破，真正实现学术与工作相结合，帮助学生实现毕业即可进名企。'
        }
      ]
    },
    'flowDiagramItems': [
      {
        'title': '个人竞争力评估、制定长期目标',
        'desc': '-专业藤途顾问将对学员进行背景能力及行业技能需求评估，确定长期目标行业及岗位',
        'img': '1.png'
      },
      {
        'title': '专属行业导师匹配',
        'desc': '-针对学员的行业技能需求，匹配最适合的行业导师，长期对学员提供指导',
        'img': '2.png'
      },
      {
        'title': '基础知识培训、相关软件使用指导',
        'desc': '-由行业导师结合目标行业岗位为学生制定学习内容，针对性的制定专属相关知识与技能学习计划，辅助学生完成除学校课程以外的课程内容学习。帮助学生在求职之前掌握入职所需的软件操作，帮助学员补足行业技能及专业知识',
        'img': '3.png'
      },
      {
        'title': '专业项目操作（一）',
        'desc': '-由行业导师手把手运用行业实际case，带领学生操作专业项目。借由操作实习项目的过程，加强行业技能及知识背景',
        'img': '4.png'
      },
      {
        'title': '专业项目成果评估',
        'desc': '-项目结束后，导师将会进行项目成果评估，提供学员完整的实习成果总结和反馈',
        'img': '5.png'
      },
      {
        'title': '简历精修/模拟面试',
        'desc': '此计划包含简历精修及模拟面试，保证学员能顺利取得面试机会',
        'img': '6.png'
      },
      {
        'title': '​获取名企暑期实习',
        'desc': '-帮助学生获得名企暑期实习',
        'img': '7.png'
      },
      {
        'title': '二次职场规划分析与评估',
        'desc': '-由行业导师结合学生暑期实习情况及实习项目成果评估，与学生就进行二次职场规划分析，结合学生实际情况与求职意愿，动态调整未来求职方向',
        'img': '8.png'
      },
      {
        'title': '专业项目操作（二）',
        'desc': '-由行业导师手把手运用行业实际case，带领学生操做实习项目（二）。借由操作实习项目的过程，加强行业进阶技能及知识背景',
        'img': '9.png'
      },
      {
        'title': '获得return offer/全职offer',
        'desc': '-帮助学生获得名企全职录用。项目结束后，导师将会进行项目成果评估，提供学员完整的实习成果总结和反馈。',
        'img': '10.png'
      },
    ],
    'goal': '藤途带领学员，一步一步走向名企！',
    'duration': '课程时长：至少需要一年（包含暑假）完成此计划',
    'achievements': [
      '名企全职Offer',
      '名企暑期实习',
      '行业导师推荐信',
      '个人专享的行业实操技能和知识'
    ],
    'welfare': [
      {
        'welfareItems': [
          {
            'descType': 'regular',
            'content': '藤途顾问'
          },
          {
            'descType': 'highlighting',
            'content': '一对一'
          },
          {
            'descType': 'regular',
            'content': '全程辅助及咨询'
          }
        ]
      },
      {
        'welfareItems': [
          {
            'descType': 'regular',
            'content': '保证取得'
          },
          {
            'descType': 'highlighting',
            'content': '面试机会'
          }
        ]
      },
      {
        'welfareItems': [
          {
            'descType': 'regular',
            'content': '享有藤途'
          },
          {
            'descType': 'highlighting',
            'content': '无限内推资源'
          }
        ]
      },
      {
        'welfareItems': [
          {
            'descType': 'regular',
            'content': '免费'
          },
          {
            'descType': 'highlighting',
            'content': '求职干货'
          },
          {
            'descType': 'regular',
            'content': '福利(网申题库、面经等)'
          }
        ]
      }
    ]
  },
  {
    'category': 'interview',
    'banner': 'interview.jpg',
    'highlight': {
      'title1': '',
      'title2': '成为最优秀的面试者 在面试中完美展现自己',
      'desc': [
        '面对目标行业的面试还不是很了解？',
        '过往面试总表现不够好，却不知道如何加强面试技巧？',
        '面对招聘官的问题，不清楚回答方向对不对？'
      ]
    },
    'projectDesc': {
      'title': '藤途面霸计划',
      'desc': [
        {
          'descType': 'regular',
          'content': '藤途面霸计划帮助同学针对目标行业'
        },
        {
          'descType': 'regular',
          'content': '提升面试技巧'
        },
        {
          'descType': 'regular',
          'content': '，并进行一系列'
        },
        {
          'descType': 'regular',
          'content': '模拟面试'
        },
        {
          'descType': 'regular',
          'content': '，由资深招聘官和行业导师一对一帮助同学针对不同行业面试流程(网申/笔试/Behavior Interview/ Technical Interview/群面等），'
        },
        {
          'descType': 'regular',
          'content': '增强各阶段面试技巧'
        },
        {
          'descType': 'regular',
          'content': '。经由不断的面试模拟练习和即时反馈，帮助同学了解面试回答话术、思维逻辑，并补足面试所需的行业知识。藤途面霸计划'
        },
        {
          'descType': 'regular',
          'content': '提供独家名企内推机会'
        },
        {
          'descType': 'regular',
          'content': '。'
        }
      ],
      'desc2': []
    },
    'flowDiagramItems': [
      {
        'title': '个人竞争力评估',
        'desc': '-专业藤途顾问将对学员进行背景能力及行业技能需求评估，并协助订定面试计划',
        'img': '1.png'
      },
      {
        'title': '专属行业导师匹配',
        'desc': '-针对学员的行业技能需求，匹配最适合的行业导师',
        'img': '2.png'
      },
      {
        'title': '面试技巧剖析',
        'desc': '-针对学员面试问题，提点面试技巧，加强辅导训练包含面试回答话术、逻辑思维、面试相关问题。',
        'img': '3.png'
      },
      {
        'title': 'Behavior Interview 培训/模拟',
        'desc': '-针对行为面试，剖析及加强行为面试技巧，拟定最佳必问问题答案，突显相关技能和个人优势。',
        'img': '4.png'
      },
      {
        'title': 'Technical Interview 培训/模拟',
        'desc': '-针对技能面试，剖析及加强技术面试知识点，模拟技术问答及Case逻辑训练。',
        'img': '5.png'
      },
      {
        'title': '完整模拟面试及反馈',
        'desc': '-由行业导师进行目标公司模拟面试、演练，并提供即时反馈帮助学生全面提升面试技巧',
        'img': '6.png'
      },
    ],
    'goal': '迅速提升面试技能 获取offer',
    'duration': '课程时长：一个月内完成计划',
    'achievements': [
      '面试技巧全面提升',
      '斩获Offer'
    ],
    'welfare': [
      {
        'welfareItems': [
          {
            'descType': 'regular',
            'content': '藤途顾问'
          },
          {
            'descType': 'highlighting',
            'content': '一对一'
          },
          {
            'descType': 'regular',
            'content': '全程辅助及咨询'
          }
        ]
      },
      {
        'welfareItems': [
          {
            'descType': 'regular',
            'content': '享有藤途'
          },
          {
            'descType': 'highlighting',
            'content': '内推资源'
          }
        ]
      },
      {
        'welfareItems': [
          {
            'descType': 'regular',
            'content': '免费'
          },
          {
            'descType': 'highlighting',
            'content': '求职干货'
          },
          {
            'descType': 'regular',
            'content': '福利(网申题库、面经等)'
          }
        ]
      }
    ]
  },
  {
    'category': 'vip',
    'banner': 'vip.jpg',
    'highlight': {
      'title1': '',
      'title2': '帮助学员探索不同行业 规划职涯发展',
      'desc': [
        '对未来职业规划没有很明确？',
        '想要更深入了解各行业？',
        '准备踏入社会却还没有实际规划出职业发展？'
      ]
    },
    'projectDesc': {
      'title': '藤途私人订制课程',
      'desc': [
        {
          'descType': 'regular',
          'content': '藤途私人定制课程，帮助学生规划未来职业发展方向，真正将求学与求职相结合。藤途私人定制课程包含8堂课，学生可自选一个或多个感兴趣的专业，由所选专业的行业精英进行一对一讲述交流。此课程，将为学员做深度咨询，帮助了解学生行业兴趣，介绍行业概况和未来发展前景。帮助学员深度了解行业工作内容及相关必备知识。让学生在进入行业前，能提前了解行业状况并制定职业发展规划，掌握选择职业的主动权。'
        }
      ],
      'desc2': []
    },
    'flowDiagramItems': [
    ],
    'goal': '',
    'duration': '',
    'achievements': [
      '了解行业基础知识',
      '未来行业规划'
    ],
    'welfare': [
      {
        'welfareItems': [
          {
            'descType': 'regular',
            'content': '藤途顾问'
          },
          {
            'descType': 'highlighting',
            'content': '一对一'
          },
          {
            'descType': 'regular',
            'content': '全程辅助及咨询'
          }
        ]
      },
      {
        'welfareItems': [
          {
            'descType': 'regular',
            'content': '课程相关纸质版及音频资料'
          }
        ]
      },
      {
        'welfareItems': [
          {
            'descType': 'regular',
            'content': '海内外交流会'
          }
        ]
      },
      {
        'welfareItems': [
          {
            'descType': 'regular',
            'content': '免费'
          },
          {
            'descType': 'highlighting',
            'content': '求职干货'
          },
          {
            'descType': 'regular',
            'content': '福利(网申题库、面经等)'
          }
        ]
      }
    ]
  }
];



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/data/careers.ts